module.exports = __webpack_public_path__ + "static/img/product_images_big16_h5_zh.1d61b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big16_h5_zh.png
// module id = U2rF
// module chunks = 34